<template>
  <main>
    <div class="row">
      <div class="col-12">
        <div class="tile">
          <div class="form-inline">
            <b-form-input class="mr-1 mb-1" v-model="filterFormModel.keyword" v-on:keydown.enter="search"
                          :placeholder="$t('keyword')"></b-form-input>
            <client-select :model="filterFormModel" class="mr-1 mb-1" attribute="client" @change="search"
                           :isFilter="true" :place-holder="$t('selectClient')"></client-select>
            <form-select :model="filterFormModel" attribute="status" class="mr-1 mb-1" :options="[
                       {value: null, text: $t('status')},
                       {value: '1', text: $t('success')},
                       {value: '2', text: $t('failed')},
                   ]"></form-select>
            <time-range-picker :model="filterFormModel" :label="$t('createTime')" class="mr-1 mb-1"></time-range-picker>
            <button @click="search" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
            <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="c-paging clearfix">
          <div class="c-paging__count" v-if="itemCount">
            {{ $t('found', [itemCount]) }}
          </div>
          <div class="c-paging__right">
            <div class="c-paging__numbers">
              <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                            v-model="filterFormModel.page" :total-rows="itemCount"
                            :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12" v-if="items.length">
        <div class="c-smart-table tile">
          <div class="row c-smart-table__title">
            <div class="col-2">{{ $t('client') }}</div>
            <div class="col-2">{{ $t('invoice') }}</div>
            <div class="col-4">{{ $t('info') }}</div>
            <div class="col-3">{{ $t('time') }}</div>
            <div class="col-1"></div>
          </div>
          <div class="row" v-for="item in items" :key="item._id">
            <div class="col-2">
              <div v-if="item.client">
                <div><b>{{ $t("companyName") }}: </b>{{ item.client.companyName }}</div>
                <div><b>{{ $t("domain") }}: </b>{{ item.client.domain }}</div>
              </div>
            </div>
            <div class="col-2">
               <div v-if="item.invoices && item.invoices.length === 1" >
                  <b>{{ $t('invoiceNumber') }}: </b>
                  <span v-if="item.invoices[0].number">{{ item.invoices[0].number }}</span>
                  <span v-else class="text-secondary small">Chưa cấp số</span>
               </div>
              <ul class="pl-0" v-else-if="item.invoices && item.invoices.length">
                <li v-for="invoice in item.invoices" :key="invoice._id">
                  <b>{{ $t('invoiceNumber') }}: </b>
                  <span v-if="invoice.number">{{ invoice.number }}</span>
                  <span v-else class="text-secondary small">Chưa cấp số</span>
                </li>
              </ul>
              <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
            </div>
            <div class="col-4">
              <div>
                <b>Endpoint URL: </b>
                <span v-if="item.endpoint">{{ item.endpoint }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <b>{{ $t('method') }}: </b>
                <span v-if="item.method">{{ item.method }}</span>
                <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
              </div>
              <div>
                <span v-if="item.success" class="badge badge-success">{{ $t('success') }}</span>
                <span v-else class="badge badge-danger">{{ $t('failed') }}</span>
                <span v-if="item.errorMsg"> {{ item.errorMsg }}</span>
              </div>
            </div>
            <div class="col-3">
              <b>{{ $t('createTime') }}: </b>
              <span v-if="item.createTime">{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
              <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
            </div>
            <div class="col-1 text-right">
              <div class="c-smart-table__content">
                <div class="c-buttons clearfix is-2">
                  <div class="c-buttons__col">
                    <button @click="showDetailModal(item)" type="button" class="btn btn-sm btn-info mr-1">
                      <font-awesome-icon icon="eye"/>&nbsp;{{ $t('detail') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 text-center text-danger" v-if="!items.length">
        <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
        <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
      </div>

      <div class="col-12" v-if="itemCount">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                      v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                      @input="load">
        </b-pagination>
      </div>
    </div>
    <b-modal v-model="showDetail" size="xl" :title="$t('detail')" @close="closeDetail" no-close-on-backdrop
             no-enforce-focus>

      <div v-if="detailItem">
        <p>
          <b>{{ $t('client') }}: </b>
          <span v-if="detailItem.client">{{ detailItem.client.domain }}</span>
          <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
        </p>
        <p>
          <b>Endpoint URL: </b>
          <span v-if="detailItem.endpoint">{{ detailItem.endpoint }}</span>
          <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
        </p>
        <p>
          <b>{{ $t('method') }}: </b>
          <span v-if="detailItem.method">{{ detailItem.method }}</span>
          <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
        </p>
        <p>
          <b>{{ $t('createTime') }}: </b>
          <span v-if="detailItem.createTime">{{ detailItem.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
          <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
        </p>
        <div class="row">
          <div class="col-6">
            <div class="mb-2">
              <b>Request</b>
              <button v-if="detailItem.requestData" @click="copy(JSON.stringify(detailItem.requestData))" type="button" class="btn btn-sm btn-primary float-right" >
                <i class="fa fa-copy" ></i>
              </button>
            </div>
            <json-viewer class="alert alert-info" theme="dark-json-viewer" v-if="detailItem.requestData"
                         :value="detailItem.requestData"
                         :expand-depth=3 :boxed=false sort/>
            <div class="alert alert-info text-danger text-center" v-else>{{ $t('noData') }}</div>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <b>Response</b>
              <button v-if="detailItem.responseData" @click="copy(JSON.stringify(detailItem.responseData))" type="button" class="btn btn-sm btn-primary float-right" >
                <i class="fa fa-copy" ></i>
              </button>
            </div>
            <json-viewer class="alert" :class="detailItem.success ? 'alert-success' : 'alert-danger'"
                         theme="dark-json-viewer" v-if="detailItem.responseData"
                         :value="detailItem.responseData"
                         :expand-depth=3 :boxed=false sort/>
            <div class="alert alert-success text-danger text-center" v-else>{{ $t('noData') }}</div>
          </div>
        </div>
      </div>

      <template v-slot:modal-footer>
        <button class="btn btn-secondary" @click="closeDetail">{{ $t('close') }}</button>
      </template>
    </b-modal>
  </main>
</template>

<script>
import List from '@/mixins/List';
import TimeRangePicker from "@/components/TimeRangePicker.vue";
import ClientSelect from "@/components/ClientSelect.vue";
import JsonViewer from 'vue-json-viewer';

export default {
  components: {TimeRangePicker, ClientSelect, JsonViewer},
  mixins: [List],
  data: function () {
    return {
      service: '/hilo-invoice-log',
      autoLoad: true,
      defaultFilterFormModel: {
        keyword: null,
        client: null,
        status: null
      },
      showDetail: false,
      detailItem: null
    }
  },
  i18n: {
    messages: {
      en: {
        invoice: 'Invoice',
        invoiceNumber: 'Invoice number',
        failed: 'Failed',
        method: 'Method',
        close: 'Close',
        noData: 'No data!'
      },
      vi: {
        invoice: 'Hóa đơn',
        invoiceNumber: 'Số hóa đơn',
        failed: 'Thất bại',
        method: 'Phương thức',
        close: 'Đóng',
        noData: 'Không có dữ liệu!'
      }
    }
  },
  methods: {
    copy(str) {
      this.$copyText(str).then(() => {
        this.$swal({
          text: "Sao chép thành công!",
          icon: 'success',
          toast: true,
          position: 'top-end',
          timer: 5000,
        });
      }, () => {
        this.$swal({
          title: this.$t('error'),
          text: this.$t('copyFailed'),
          icon: 'error'
        });
      })
    },
    search() {
      this.filterFormModel.page = 1;
      this.load()
    },
    load: function () {
      let loader = this.$loading.show();
      this.loading = true;
      this.listLoading = true;
      this.$service.get(this.service, {
        params: this.filterFormModel
      }).then(response => {
        this.apply(response.data);
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        loader.hide();
        this.loading = false;
        this.listLoading = false;
        if (this.afterLoad) {
          this.afterLoad();
        }
      });
    },
    showDetailModal(item) {
      this.detailItem = item
      this.showDetail = true
    },
    closeDetail() {
      this.detailItem = null
      this.showDetail = false
    }
  }
};
</script>